// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes homeFadeUp {
  from {
    opacity: 0;
    transform: translateY(24px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes homeFloat {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-12px);
  }
}
.homePage {
  font-family: "Outfit", system-ui, sans-serif;
  color: #1a1f2c;
  background: #ffffff;
  overflow-x: hidden;
}
.homePage h1,
.homePage h2,
.homePage h3,
.homePage h4,
.homePage .homeBrand,
.homePage .homeDisplay {
  font-family: "Plus Jakarta Sans", system-ui, sans-serif;
  letter-spacing: -0.02em;
}
.homePage p,
.homePage h6,
.homePage li,
.homePage input,
.homePage button,
.homePage a {
  font-family: "Outfit", system-ui, sans-serif;
}
.homePage .homeReveal {
  opacity: 0;
  transform: translateY(28px);
  transition: opacity 0.7s ease, transform 0.7s ease;
}
.homePage .homeReveal.is-visible {
  opacity: 1;
  transform: translateY(0);
}
.homePage .homeCtaPrimary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.9rem 1.6rem;
  border-radius: 999px;
  background: #3fb9ea;
  color: #fff !important;
  text-decoration: none !important;
  font-weight: 600;
  font-size: 1rem;
  border: none;
  transition: background 0.25s ease, transform 0.25s ease;
}
.homePage .homeCtaPrimary:hover {
  background: #1a9fd4;
  transform: translateY(-1px);
  color: #fff !important;
}
.homePage .homeCtaGhost {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.9rem 1.2rem;
  color: #1a1f2c !important;
  text-decoration: none !important;
  font-weight: 600;
  border-radius: 999px;
  border: 1px solid rgba(26, 31, 44, 0.08);
  background: transparent;
  transition: border-color 0.25s ease, color 0.25s ease;
}
.homePage .homeCtaGhost:hover {
  border-color: #3fb9ea;
  color: #1a9fd4 !important;
}

@media (prefers-reduced-motion: reduce) {
  .homePage .homeReveal {
    opacity: 1;
    transform: none;
    transition: none;
  }
  .homePage .homeHero__brand,
  .homePage .homeHero__title,
  .homePage .homeHero__disc,
  .homePage .homeHero__actions {
    animation: none !important;
    opacity: 1 !important;
  }
  .homePage .homeHero__img {
    animation: none !important;
  }
  .homePage .homeWhy__item:hover,
  .homePage .homeProducts__tile:hover {
    transform: none;
  }
}
@media (max-width: 575px) {
  .homePage .homeCtaPrimary,
  .homePage .homeCtaGhost {
    width: 100%;
    justify-content: center;
  }
  .homePage .homeHero__actions {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Home/home-tokens.scss","webpack://./src/Components/Home/Home.scss"],"names":[],"mappings":"AA2BA;EACE;IACE,UAAA;IACA,2BAAA;EC1BF;ED4BA;IACE,UAAA;IACA,wBAAA;EC1BF;AACF;AD6BA;EACE;IAEE,wBAAA;EC5BF;ED8BA;IACE,4BAAA;EC5BF;AACF;AAfA;EACE,4CDMU;ECLV,cDJS;ECKT,mBDDW;ECEX,kBAAA;AAiBF;AAfE;;;;;;EAME,uDDNW;ECOX,uBAAA;AAiBJ;AAdE;;;;;;EAME,4CDfQ;AC+BZ;AAbE;EDVA,UAAA;EACA,2BAAA;EACA,kDAAA;AC0BF;ADxBE;EACE,UAAA;EACA,wBAAA;AC0BJ;AAlBE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBDjCQ;ECkCR,sBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,uDAAA;AAoBJ;AAlBI;EACE,mBDzCW;EC0CX,2BAAA;EACA,sBAAA;AAoBN;AAhBE;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,yBAAA;EACA,gCAAA;EACA,gBAAA;EACA,oBAAA;EACA,wCAAA;EACA,uBAAA;EACA,qDAAA;AAkBJ;AAhBI;EACE,qBD9DM;EC+DN,yBAAA;AAkBN;;AAbA;EAEI;IACE,UAAA;IACA,eAAA;IACA,gBAAA;EAeJ;EAZE;;;;IAIE,0BAAA;IACA,qBAAA;EAcJ;EAXE;IACE,0BAAA;EAaJ;EAVE;;IAEE,eAAA;EAYJ;AACF;AARA;EAEI;;IAEE,WAAA;IACA,uBAAA;EASJ;EANE;IACE,WAAA;EAQJ;AACF","sourcesContent":["$home-ink: #1a1f2c;\r\n$home-muted: #5c6578;\r\n$home-line: rgba(26, 31, 44, 0.08);\r\n$home-mist: #f4f7fb;\r\n$home-paper: #ffffff;\r\n$home-teal: #3fb9ea;\r\n$home-teal-deep: #1a9fd4;\r\n$home-red: #d60000;\r\n$home-display: \"Plus Jakarta Sans\", system-ui, sans-serif;\r\n$home-body: \"Outfit\", system-ui, sans-serif;\r\n\r\n@mixin home-container {\r\n  width: min(1120px, calc(100% - 2.5rem));\r\n  margin-inline: auto;\r\n}\r\n\r\n@mixin home-reveal {\r\n  opacity: 0;\r\n  transform: translateY(28px);\r\n  transition: opacity 0.7s ease, transform 0.7s ease;\r\n\r\n  &.is-visible {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes homeFadeUp {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(24px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes homeFloat {\r\n  0%,\r\n  100% {\r\n    transform: translateY(0);\r\n  }\r\n  50% {\r\n    transform: translateY(-12px);\r\n  }\r\n}\r\n","@import \"./home-tokens.scss\";\n\n.homePage {\n  font-family: $home-body;\n  color: $home-ink;\n  background: $home-paper;\n  overflow-x: hidden;\n\n  h1,\n  h2,\n  h3,\n  h4,\n  .homeBrand,\n  .homeDisplay {\n    font-family: $home-display;\n    letter-spacing: -0.02em;\n  }\n\n  p,\n  h6,\n  li,\n  input,\n  button,\n  a {\n    font-family: $home-body;\n  }\n\n  .homeReveal {\n    @include home-reveal;\n  }\n\n  .homeCtaPrimary {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    padding: 0.9rem 1.6rem;\n    border-radius: 999px;\n    background: $home-teal;\n    color: #fff !important;\n    text-decoration: none !important;\n    font-weight: 600;\n    font-size: 1rem;\n    border: none;\n    transition: background 0.25s ease, transform 0.25s ease;\n\n    &:hover {\n      background: $home-teal-deep;\n      transform: translateY(-1px);\n      color: #fff !important;\n    }\n  }\n\n  .homeCtaGhost {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.4rem;\n    padding: 0.9rem 1.2rem;\n    color: $home-ink !important;\n    text-decoration: none !important;\n    font-weight: 600;\n    border-radius: 999px;\n    border: 1px solid $home-line;\n    background: transparent;\n    transition: border-color 0.25s ease, color 0.25s ease;\n\n    &:hover {\n      border-color: $home-teal;\n      color: $home-teal-deep !important;\n    }\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .homePage {\n    .homeReveal {\n      opacity: 1;\n      transform: none;\n      transition: none;\n    }\n\n    .homeHero__brand,\n    .homeHero__title,\n    .homeHero__disc,\n    .homeHero__actions {\n      animation: none !important;\n      opacity: 1 !important;\n    }\n\n    .homeHero__img {\n      animation: none !important;\n    }\n\n    .homeWhy__item:hover,\n    .homeProducts__tile:hover {\n      transform: none;\n    }\n  }\n}\n\n@media (max-width: 575px) {\n  .homePage {\n    .homeCtaPrimary,\n    .homeCtaGhost {\n      width: 100%;\n      justify-content: center;\n    }\n\n    .homeHero__actions {\n      width: 100%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
